export default __webpack_public_path__ + "static/media/640_business01-it-web.0c3e47d3.png";